export default {
  Weekly: { label: 'Weekly', value: 'WK' },
  Fortnightly: { label: 'Fortnightly', value: 'FN' },
  FourWeekly: { label: 'Four-Weekly', value: 'FW' },
  Monthly: { label: 'Monthly', value: 'MN' },
  BiMonthly: { label: 'Bi-Monthly', value: 'BM' },
  Quarterly: { label: 'Quarterly', value: 'QT' },
  OneOff: { label: 'One-Off', value: 'OF' },
};
